import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch } from "vue";
import { StatusClassNames } from "../types/StatusClassNames";
import { onTransitionEnd } from "../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextPreloader',
    props: {
        active: { type: Boolean, default: true },
    },
    setup: function (__props) {
        var props = __props;
        var show = ref(props.active);
        var isActive = ref(props.active);
        var el = ref();
        watch(function () { return props.active; }, function (value) {
            if (value) {
                show.value = true;
                setTimeout(function () { return isActive.value = true; }, 20);
            }
            else {
                isActive.value = false;
                onTransitionEnd(el.value, function () { return show.value = false; }, 'opacity');
            }
        });
        return function (_ctx, _cache) {
            var _a;
            return (show.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["text-preloader", (_a = {}, _a[_unref(StatusClassNames).active] = isActive.value, _a)]),
                    ref_key: "el",
                    ref: el
                }, null, 2 /* CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
